import {Location} from '@angular/common';
import {AfterViewInit, ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';

@Component({
    selector: 'app-cookie-notice',
    templateUrl: './cookie-notice.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieNoticeComponent implements AfterViewInit {
    readonly message = 'cookie-notice_message';
    readonly dismiss = 'cookie-notice_dismiss';
    readonly allow = 'cookie-notice_allow';
    readonly deny = 'cookie-notice_deny';
    readonly link = 'cookie-notice_link';

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    public constructor(private ccService: NgcCookieConsentService,
                       private router: Router,
                       private location: Location) {
    }

    ngAfterViewInit(): void {
        const config = this.ccService.getConfig();

        const domain = location.hostname;
        console.log('domain set to', domain);

        config.cookie = {
            domain: domain
        };

        config.content = {
            message: this.i18nDictionary.get(this.message),
            dismiss: this.i18nDictionary.get(this.dismiss),
            allow: this.i18nDictionary.get(this.allow),
            deny: this.i18nDictionary.get(this.deny),
            link: this.i18nDictionary.get(this.link),
            href: this.location.prepareExternalUrl('/privacy')
        };

        this.ccService.destroy();
        this.ccService.init(config);
    }
}
